var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.326172,
    y: 0.3479,
    width: 45.8696,
    height: 45.8696,
    rx: 5,
    fill: "#439CB6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2715 13.1021H33.2155V36.2012H13.2715V13.1021Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2715 13.1021H33.2155V36.2012H13.2715V13.1021Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6309 23.0185C30.7359 22.2024 30.7015 21.367 30.5275 20.5637C30.2978 19.5024 29.8246 18.4974 29.1081 17.6676C28.3916 16.8377 27.5238 16.2897 26.6076 16.0236C25.914 15.8222 25.1926 15.7823 24.488 15.9039",
    stroke: "white",
    strokeWidth: 1.662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4775 22.6321C27.59 21.7578 27.3557 20.8353 26.7747 20.1624C26.1936 19.4894 25.3971 19.218 24.6423 19.3484",
    stroke: "white",
    strokeWidth: 1.662,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2447 17.334C19.5465 17.334 19.8246 17.5236 19.9712 17.8293L20.9877 19.95C21.1208 20.2277 21.127 20.5635 21.0044 20.8476L20.0251 23.1159C20.0251 23.1159 20.3089 24.8058 21.4966 26.1813C22.6843 27.5569 24.1384 27.8799 24.1384 27.8799L26.0966 26.7459C26.342 26.6038 26.6322 26.6111 26.872 26.7656L28.7082 27.9479C28.9719 28.1177 29.1354 28.4397 29.1354 28.7891V31.2307C29.1354 32.474 28.1383 33.3721 27.1211 32.9745C25.032 32.1581 21.7892 30.6036 19.7338 28.223C17.6783 25.8425 16.3362 22.0866 15.6313 19.667C15.2881 18.4889 16.0634 17.334 17.1369 17.334H19.2447Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.662,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/Phone-icon.f85fb92d019d013b50d4961a8cd67e31.svg";
export { ForwardRef as ReactComponent };